<form [formGroup]="languageForm" class="language-form" *ngIf="!isLoading && languageList">
    <mat-form-field floatLabel="never">
        <mat-select placeholder="{{ 'main.languageSelector.shortLabel' | translate }}" name="lang" formControlName="lang">
            <mat-option *ngFor="let language of languageList" [value]="language">
                {{ language.codeISO }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</form>
